import { apiClient } from "@/lib/apiClient";
import type { ProvisionStockDto, ProvisionStockStateDto } from "@/types/stock.types";

export const PROVISION_STOCKS_KEY = "provision-stocks/";

export const listProvisionStocks = async (): Promise<ProvisionStockDto[]> => {
  const stocks = await apiClient.get<ProvisionStockDto[]>(PROVISION_STOCKS_KEY);
  return Array.isArray(stocks) ? stocks : [];
};

export const getProvisionStock = (id: string): Promise<ProvisionStockStateDto> =>
  apiClient.get<ProvisionStockStateDto>(`provision-stocks/${id}`);
